import React, { useState } from 'react';
import { useStore } from 'effector-react';
import { getSupportTasks, postSupportTasks, getAllMonthSprints, getCategoriesTasks } from '../components/api';
import { $supportTasks, $users, $authUserData, setSupportTasks, $customers } from '../store/cards';
import { SupportTaskRow } from '../components';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Button,
    Select,
    MenuItem,
    IconButton
} from '@mui/material';
import {
    Close,
    ArrowLeft,
    ArrowRight,
} from '@mui/icons-material';
import '../styles/month-report.scss';
import '../styles/table-combobox.scss';

export function SupportMonthReportPage() {
    const users = useStore($users);
    const customers = useStore($customers);
    const authUserData = useStore($authUserData);
    const [isLoaded, setIsLoaded] = useState(false);
    const supportTasks = useStore($supportTasks);
    const [sprints, setSprints] = useState([]);
    const [responsibleSelectValue, setResponsibleSelectValue] = useState(0);
    const [selectedSprint, setSelectedSprint] = useState(`${new Date().getMonth() + 1};${new Date().getFullYear()}`);
    const [isLoadingData, setIsLoadingData] = useState(false);
    const [categorySelectValue, setCategorySelectValue] = useState(-1);
    const [statusSelectValue, setStatusSelectValue] = useState(0);
    const [customerSelectValue, setCustomerSelectValue] = useState(0);
    const [categoriesTasks, setCategoriesTasks] = useState([]);

    React.useEffect(() => {
        document.title = "TaskMan - Задачи поддержки";
    });

    const getSprintData = () => {
        const sprintData = selectedSprint.target ? selectedSprint.target.value : selectedSprint;
        const [month, year] = sprintData.split(';');
        return {
            month: month,
            year: year
        }
    }

    React.useEffect(() => {
        getAllMonthSprints().then(data => setSprints(data));
        if (sprints.length) {
            setSelectedSprint(`${sprints[0].month};${sprints[0].year}`);
        }
    }, [sprints.length]);

    React.useEffect(() => {
        getCategoriesTasks().then(data => {
            setCategoriesTasks(data);
        });
    }, []);

    const loadData = () => {
        const { month, year } = getSprintData();

        getSupportTasks(year, month).then(monthSupportReport => {
            setSupportTasks(monthSupportReport);
            setIsLoaded(true);
        });
    }

    React.useEffect(() => {
        const { month, year } = getSprintData();

        getSupportTasks(year, month).then(monthSupportReport => {
            setSupportTasks(monthSupportReport);
            setIsLoaded(true);
        });
    }, [isLoaded, selectedSprint]);

    const changeSelectResponsible = (event) => {
        setResponsibleSelectValue(event.target.value);
    }

    const changeSelectStatus = (event) => {
        setStatusSelectValue(event.target.value);
    }

    const getSupportSPCount = () => {
        const supportTask = categoriesTasks.map((category) => {
            
            const supportTasksByCategory = filteredTasks.filter(t => t.category.id === category.id && t.completion_date !== null);
            const spCount = supportTasksByCategory.length ? supportTasksByCategory
                .reduce((partialSum, a) => partialSum + (a.sp_count ?? category?.default_volume ?? 0), 0)
                .toFixed(2) : 0;
                return {
                    categoryId: category.id,
                    count: supportTasksByCategory.length,
                    sp: Number(spCount)
                };
        }, 0);
        
        const totalSP = supportTask.length ? supportTask.reduce((sum, task) => sum + task.sp, 0) : 0;
        const countTask = supportTask.length ? supportTask.reduce((sum, task) => sum + task.count, 0) : 0;
        const tasksWithoutCategoryCount = filteredTasks.filter(task => task.deadline === null).length;
        const tasksCount = filteredTasks.filter(task => task.completion_date !== null).length;
        const overdueTasksCount = filteredTasks.filter(task => task.status.id === -1).length;
        const completedOnTime = tasksCount
            ? Math.round((tasksCount - tasksWithoutCategoryCount - overdueTasksCount) / tasksCount * 100)
            : 0;
        const supportSpCount = [
            `${(Number(totalSP)).toFixed(2)} SP (${countTask})`,
            `${completedOnTime} %`,
            filteredTasks.filter(task => task.status.id === 4).length,
            tasksWithoutCategoryCount,
            overdueTasksCount
        ];
        if(supportTask.length){
            supportTask.forEach((task) => {
                supportSpCount.push(`${task.sp} SP (${task.count})`);
            });
        }
        return supportSpCount;
    }

    const loadSupportTasksClick = () => {
        setIsLoadingData(true);
        const { month, year } = getSprintData();
        postSupportTasks(year, month).then(() => {
            getSupportTasks(year, month).then(monthReport => {
                setSupportTasks(monthReport);
                setIsLoadingData(false);
            });
        });

    }

    const formattedData = (month, year) => {
        var options = {
            year: 'numeric',
            month: 'long',
            timezone: 'UTC'
        };
        const date = new Date(`${year}-${month}-01`);
        return `${date.toLocaleString("ru", options)}`
    };

    const changeSelectedSprint = (event) => {
        setSelectedSprint(event.target.value);
    }

    const filteredTasks = supportTasks.map(card => {
        if (!card.customer) {
            card.customer = {
                id: -1,
                name: ""
            };
        }
        return card;
    }).filter(task => {
        const hasResponsible = Number(responsibleSelectValue) === 0 ? true : Number(task.responsible_id) === Number(responsibleSelectValue);
        const hasStatus = Number(statusSelectValue) === 0 ? true : Number(task.status.id) === Number(statusSelectValue);
        const hasCategory = Number(categorySelectValue) === -1 ? true : Number(task.category.id) === Number(categorySelectValue);
        const hasCustomer = Number(customerSelectValue) === 0 ? true : Number(task.customer ? task.customer.id : 0) === Number(customerSelectValue);
        return hasResponsible && hasStatus && hasCategory && hasCustomer;
    });

    const previousMonth = () => {
        const { month, year } = getSprintData();
        const date = new Date(`${year}-${month}-01`);
        date.setMonth(date.getMonth() - 1);
        setSelectedSprint(`${date.getMonth() + 1};${date.getFullYear()}`)
    }

    const nextMonth = () => {
        const { month, year } = getSprintData();
        const date = new Date(`${year}-${month}-01`);
        date.setMonth(date.getMonth() + 1);
        setSelectedSprint(`${date.getMonth() + 1};${date.getFullYear()}`)
    }

    const getSprintMonthYearToSelect = (sprint) => {
        return sprint ? `${sprint.month};${sprint.year}` : `${new Date().getMonth() + 1};${new Date().getFullYear()}`;
    }

    return (
        <div>
            <div className='month-report__month-controls'>
                <IconButton
                    style={{ padding: 0 }}
                    onClick={() => previousMonth()}
                    disabled={getSprintMonthYearToSelect(sprints[sprints.length - 1]) === selectedSprint}
                >
                    <ArrowLeft />
                </IconButton>
                <Select className='month-report__sprints-combobox' onChange={changeSelectedSprint} value={selectedSprint}>
                    {sprints.map((sprint) => {
                        return (<MenuItem value={getSprintMonthYearToSelect(sprint)} key={sprint.month + sprint.year}>{`${formattedData(sprint.month, sprint.year)}`}</MenuItem>)
                    })}
                </Select>
                <IconButton
                    style={{ padding: 0 }}
                    onClick={() => nextMonth()}
                    disabled={getSprintMonthYearToSelect(sprints[0]) === selectedSprint}
                >
                    <ArrowRight />
                </IconButton>
                {authUserData && authUserData.is_head_of_department ? <Button variant="contained" onClick={loadSupportTasksClick} disabled={isLoadingData} style={{ marginLeft: "10px" }}>Загрузить</Button> : null}
            </div>
            <h3>Задачи</h3>
            <TableContainer component={Paper}>
                <Table sx={{ minWidth: 300 }} size="small" aria-label="simple table">
                    <TableHead>
                        <TableRow>
                            <TableCell width={10} align="center"><b>Всего</b></TableCell>
                            <TableCell width={10} align="center"><b>Завершены в срок</b></TableCell>
                            <TableCell width={10} align="center"><b>Ждут контроля</b></TableCell>
                            <TableCell width={10} align="center"><b>Без крайнего срока</b></TableCell>
                            <TableCell width={10} align="center"><b>Просрочены</b></TableCell>
                            {categoriesTasks.map(category => 
                                <TableCell width={10} align="center"><b>{category.name}</b></TableCell>
                            )}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <TableRow>
                            {getSupportSPCount().map(element => 
                                <TableCell width={10} align="center"><b>{element}</b></TableCell>
                            )}
                        </TableRow>
                    </TableBody>
                </Table>
            </TableContainer>
            <TableContainer component={Paper} sx={{ maxHeight: "calc(100vh - 200px)" }}>
                <Table stickyHeader sx={{ minWidth: 650 }} size="small" aria-label="simple sticky table">
                    <TableHead>
                        <TableRow>
                            <TableCell></TableCell>
                            <TableCell width={50} align="center" className="table-column">
                                <div className="table-column__item" style={{width: '140px'}}>
                                    <Select
                                        className='table-combobox'
                                        value={customerSelectValue}
                                        onChange={(event) => setCustomerSelectValue(event.target.value)}
                                        style={{marginLeft: "10px"}}
                                    >
                                        <MenuItem value={0} key={0}>Заказчик</MenuItem>
                                        <MenuItem value={-1} key={-1}>Без заказчика</MenuItem>
                                        {customers.map((customer) => {
                                            return supportTasks.filter(supportTask => supportTask.customer && supportTask.customer.id === customer.id).length
                                                ? (<MenuItem value={customer.id} key={customer.id}>{customer.name}</MenuItem>)
                                                : null
                                        })}
                                    </Select>
                                    {
                                        customerSelectValue
                                            ? <IconButton onClick={() => setCustomerSelectValue(0)}>
                                                <Close style={{ fontSize: 16 }} />
                                            </IconButton>
                                            : null
                                    }

                                </div>
                            </TableCell>
                            <TableCell width={200} align="center">
                                <div>
                                    <Select className='table-combobox__header' value={categorySelectValue}  onChange={(event) => setCategorySelectValue(event.target.value)}>
                                        <MenuItem value={-1} key={-1}>Категория</MenuItem>
                                        {categoriesTasks.map(category => {
                                            return (<MenuItem value={category.id} key={category.bitrix_code}>{category.name}</MenuItem>)
                                        })}
                                    </Select>
                                    {
                                        categorySelectValue !== -1
                                            ? <IconButton onClick={() => setCategorySelectValue(-1)}>
                                                <Close style={{ fontSize: 16 }} />
                                            </IconButton>
                                            : null
                                    }
                                </div>
                            </TableCell>
                            <TableCell width={10}><b>№</b></TableCell>
                            <TableCell width={'24%'} align="left"><b>Название</b></TableCell>
                            <TableCell width={150}>
                                <div className='table-header__column'>
                                    <Select className='table-combobox__header' value={responsibleSelectValue} onChange={changeSelectResponsible}>
                                        <MenuItem value={0} key={0}>Исполнитель</MenuItem>
                                        {users.filter(user => (
                                            user.active && supportTasks.filter(task => task.responsible_id === Number(user.bitrix_user_id)).length) && user.id !== -1
                                        ).map((user) => {
                                            return (<MenuItem value={user.bitrix_user_id} key={user.id}>{`${user.surname} ${user.name}`}</MenuItem>)
                                        })}
                                    </Select>
                                    {
                                        responsibleSelectValue !== 0
                                            ? <IconButton onClick={() => setResponsibleSelectValue(0)}>
                                                <Close style={{ fontSize: 16 }} />
                                            </IconButton>
                                            : null
                                    }
                                </div>
                            </TableCell>
                            <TableCell width={10} align="center"><b>SP</b></TableCell>
                            <TableCell width={130} align="center"><b>Крайний срок</b></TableCell>
                            <TableCell width={140} align="center"><b>Дата завершения</b></TableCell>
                            <TableCell width={130} align="center"><b>Дата закрытия</b></TableCell>
                            <TableCell width={200} align="center">
                                <div>
                                    <Select className='table-combobox__header' value={statusSelectValue} onChange={changeSelectStatus}>
                                        <MenuItem value={0} key={0}>Статус</MenuItem>
                                        <MenuItem value={-1} key={-1}>Просрочена</MenuItem>
                                        <MenuItem value={4} key={30}>Ждет контроля</MenuItem>
                                        <MenuItem value={5} key={31}>Завершена</MenuItem>
                                    </Select>
                                    {
                                        statusSelectValue !== 0
                                            ? <IconButton onClick={() => setStatusSelectValue(0)}>
                                                <Close style={{ fontSize: 16 }} />
                                            </IconButton>
                                            : null
                                    }
                                </div>
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {filteredTasks.map((task) => {
                            return (
                                <SupportTaskRow
                                    key={task.id}
                                    task={task}
                                    setCategorySelectValue={setCategorySelectValue}
                                    setResponsibleSelectValue={setResponsibleSelectValue}
                                    setStatusSelectValue={setStatusSelectValue}
                                    setCustomerSelectValue={setCustomerSelectValue}
                                    loadData={loadData}
                                />
                            )
                        })}
                    </TableBody>
                </Table>
            </TableContainer>
        </div>
    );
}